export interface Nutzung {
  id              : number;
  messageProperty : string;
}

export enum NutzungId {
  NUTZTIER = 10,
  HEIMTIER = 50
}
